import { Navigate, Route, Routes } from "react-router-dom"
import React from "react"

const OrdersPage = React.lazy(() => import("./OrdersPage"))
const StoreKeeperPlacementsPage = React.lazy(() => import("./PlacementsPage"))
const DelegatedListingsPage = React.lazy(() => import("./DelegatedListings"))

export const StoreKeeperRoutes = () => {
    return (
        <Routes>
            <Route path={`orders`} element={<OrdersPage />} />
            <Route
                path={`listings/:id`}
                element={<StoreKeeperPlacementsPage />}
            />
            <Route
                path={`delegatedListings`}
                element={<DelegatedListingsPage />}
            />
            <Route path="*" element={<Navigate to={`orders`} />} />
        </Routes>
    )
}
